import { render } from "./TalleresPrincipal.vue?vue&type=template&id=78c7dce9"
import script from "./TalleresPrincipal.vue?vue&type=script&lang=js"
export * from "./TalleresPrincipal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__